import declare from 'dojo/_base/declare';
import connect from 'dojo/_base/connect';
import lang from 'dojo/_base/lang';
import arr from 'dojo/_base/array';
import color from 'dojo/_base/Color';
import keys from 'dojo/keys';
import _WidgetBase from 'dijit/_WidgetBase';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import _WidgetsInTemplateMixin from 'dijit/_WidgetsInTemplateMixin';
import template from './RatingDialog.html?raw';
import registry from 'dijit/registry';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstruct from 'dojo/dom-construct';
import mouse from 'dojo/mouse';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from 'more/GenericDialog/GenericDialog';
export default declare("WidgetCollection.Occurrence.RatingDialog.RatingDialog", [_WidgetBaseSP], {

        templateString: template,
        callback: function () { },
        genericDialog: null,
        entity: null,
        selectedRating: null,
        comment: null,

        _headingAttribute: "ID",

        postMixInProperties: function(){
            this.inherited(arguments); // standard code aus basisklasse

        },
        postCreate: function () { // markup wurde eingelesen und im html-document angelegt
            this.inherited(arguments);

            this.placeAt(document.body);
        },

        _setEntityAttr: function (entity, valueAttribute, commentAttribute, headingAttribute) {
            this.entity = entity;

            this.selectedRating = entity[valueAttribute];
            this.comment = entity[commentAttribute];

            if (typeof (headingAttribute) != "undefined") {
                this._headingAttribute = headingAttribute;
            }

            console.log("rating dialog entity", this.entity, this.selectedRating, this.comment);
        },

        startup: function () {  // ganz am ende nach instanzierung. zb zum größe berechnen oder abhängigkeiten anderer widgets prüfen
            this.inherited(arguments);

            var dialog = new GenericDialog();

            dialog.hideSubtitleNode();

            this.genericDialog = dialog;
            domStyle.set(dialog.textNode, "height", "unset");

            var value = this.selectedRating;//.getValue();
            this.selectedRating = value;

            this.drawRatingStars();

            var input = domConstruct.create("textarea");
            domClass.add(input, "w3-input w3-block");
            dialog.addNodeToContent(input);
            domAttr.set(input, "placeholder", this.translations["OccurrenceRating__DialogPlaceholderNotes"]);//"Anmerkungen?");

            if (this.comment != null && this.comment != "") {
                domAttr.set(input, "value", this.comment);
            }

            // verhinden dass mit "Enter" der Dialog beendet wird
            on(input, "keyup", function (evt) {
                evt.stopPropagation();
            });

            dialog.set("header", this.translations["OccurrenceRating__DialogHeading"].format( this.entity[this._headingAttribute]) );
            //dialog.set("content", "Hier Freitexteingabe");
            dialog.set("callback", lang.hitch(this, "ratingDialogCallback", input));

            dialog.set("ok", true);
            dialog.set("cancel", true);

            dialog.show();
        },
        destroy: function () {
            this.inherited(arguments);
        },

        ratingDialogCallback: function (input, result) {
            
            this.comment = input.value;
            //console.log("ratingDialogCallback", input, result, this.selectedRating, "Anm: " + this.comment);

            if (result != 1) {
                this._onEndRating(result);
                return;
            }

            var dialog = new GenericDialog();
            dialog.hideSubtitleNode();
            this.genericDialog = dialog;
            domStyle.set(dialog.textNode, "height", "unset");
            dialog.set("header", this.translations["OccurrenceRating__DialogHeading"].format(this.entity[this._headingAttribute]));//"Bewertung");
            dialog.set("content", this.translations["OccurrenceRating__DialogSaveProgress"]);//"Bewertung wird gespeichert...")

            dialog.show();

            dialog.StandbyStart();

            this.updateRating();
        },

        selectRating: function (value, evt) {

            //// Ausnahme: 0 Sterne vergeben indem auf den 1er-Stern zweimal geklickt wird
            //if (this.selectedRating == 1 && value == 1) {
            //    value = 0;
            //}
            this.selectedRating = value;

            this.drawRatingStars();
        },

        drawRatingStars: function () {

            var dialog = this.genericDialog;

            domConstruct.empty(dialog.subTitleNode);

            var currentValue = this.selectedRating;

            for (var i = 1; i <= 5; i++) {
                var star = domConstruct.create("i");

                if (currentValue >= i) {
                    domClass.add(star, "w3-xlarge w3-text-amber fa fa-star mds-text-hover-dark");
                } else {
                    domClass.add(star, "w3-xlarge w3-text-amber fa fa-star-o mds-text-hover-dark");
                }

                dialog.addNodeToSubtitle(star);

                on(star, "click", lang.hitch(this, "selectRating", i));
            }
        },

        updateRating: function () {

            var entityId = this.entity.ID;
            var value = this.selectedRating;
            var text = this.comment;
            //console.log("save rating", entityIds, values);

            var url = window.appRoot + "Occurrence/SaveRating";

            this.RequestManager.post(
                url,
                {
                    entityId: entityId,
                    value: value,
                    comment: text
                },
                lang.hitch(this, "_onSaveRatingResponse"),
                lang.hitch(this, "_onSaveRatingError"),
                false // sync
            );
        },

        _onSaveRatingResponse: function (response) {
            this.genericDialog.StandbyEnd();
            var message = "<p>" + this.translations["OccurrenceRating__DialogSubmitResponse"] + "</p>";
            this.genericDialog.set("content", message); //"Vielen Dank für Ihre Bewertung.");

            this.genericDialog.set("callback", lang.hitch(this, "_onEndRating"));
            this.genericDialog.set("ok", true);
        },

        _onSaveRatingError: function (error) {
            console.error("Bewertung konnte nicht gespeichert werden", error.Message);
            this.genericDialog.StandbyEnd();

            this.genericDialog.set("content", this.translations["OccurrenceRating__DialogSubmitResponseError"].format(error.Message));//Fehler beim Speichern: " + error.Message);
            this.genericDialog.set("cancel", true);
            // Benutzer irgendwie informieren??
            //alert(error.Message);
        },

        _onEndRating: function (result) {
            this.removeUrlAction("rate");
            if (typeof (this.callback) == "function") {
                this.callback(result, this.selectedRating);
            }
        }

    })
